import React from 'react';
import styled from 'styled-components';
import Selector from '../Inputs/Select';
import { getCountryFlag } from '../../common/countries';
import { useGetGlobetopperCountriesQuery } from '../../redux/api/public/globetopper';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const CountrySelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CountrySelector = ({
  value,
  onChange,
  label = 'Country',
  minWidth = '200px',
  selectedLabelOverride,
  selectedValueStyle,
  hideChevron = false,
}) => {
  const { data: countriesData = [] } = useGetGlobetopperCountriesQuery();

  const options = React.useMemo(
    () =>
      countriesData.map((country) => {
        const code = String(country.iso2).toUpperCase();
        const name = String(country.name);
        return {
          value: code,
          label: `${getCountryFlag(code)} ${name}`.trim(),
          flag: getCountryFlag(code),
          countryName: name,
        };
      }),
    [countriesData],
  );

  return (
    <CountrySelectorContainer>
      <Selector
        label={label}
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Select country"
        style={{ minWidth }}
        selectedLabelOverride={selectedLabelOverride}
        selectedValueStyle={selectedValueStyle}
        hideChevron={hideChevron}
      />
    </CountrySelectorContainer>
  );
};

export default CountrySelector;
